module.exports = __webpack_public_path__ + "img/privilege8.a7961be0.png";